import * as jsrsasign from 'jsrsasign';
import { Signature } from "../entities";
import { canonicalize } from './canonicalize';
export function getDigest(data) {
    const messageDigest = new jsrsasign.KJUR.crypto.MessageDigest({
        alg: 'sha256',
        prov: 'cryptojs',
    });
    const dataString = canonicalize(data);
    messageDigest.updateHex(jsrsasign.utf8tohex(dataString));
    const digest = messageDigest.digest();
    return {
        digest: jsrsasign.hextob64(digest),
        digestMethod: 'HS256',
    };
}
export function getFileDigest(data) {
    const messageDigest = new jsrsasign.KJUR.crypto.MessageDigest({
        alg: 'sha256',
        prov: 'cryptojs',
    });
    const dataString = data.toString('binary');
    messageDigest.updateHex(jsrsasign.rstrtohex(dataString));
    const digest = messageDigest.digest();
    return {
        digest: jsrsasign.hextob64(digest),
        digestMethod: 'HS256',
    };
}
export function signEcdsa(data, keyId, privateKeyPem) {
    const dataString = canonicalize(data);
    const privateKey = jsrsasign.KEYUTIL.getKey(privateKeyPem);
    const signatureObj = new jsrsasign.KJUR.crypto.Signature({ alg: 'SHA256withECDSA' });
    signatureObj.init(privateKey);
    signatureObj.updateHex(jsrsasign.utf8tohex(dataString));
    const signature = signatureObj.sign();
    return new Signature(jsrsasign.hextob64(signature), keyId, 'ES256');
}
export function verifyEcdsa(data, signature, publicKeyPem) {
    const dataString = canonicalize(data);
    const publicKey = jsrsasign.KEYUTIL.getKey(publicKeyPem);
    const signatureObj = new jsrsasign.KJUR.crypto.Signature({ alg: 'SHA256withECDSA' });
    signatureObj.init(publicKey);
    signatureObj.updateHex(jsrsasign.utf8tohex(dataString));
    return signatureObj.verify(jsrsasign.b64tohex(signature.value));
}
export function signFile(data, keyId, privateKeyPem) {
    const dataString = data.toString('binary');
    const privateKey = jsrsasign.KEYUTIL.getKey(privateKeyPem);
    const signatureObj = new jsrsasign.KJUR.crypto.Signature({ alg: 'SHA256withECDSA' });
    signatureObj.init(privateKey);
    signatureObj.updateHex(jsrsasign.rstrtohex(dataString));
    const signature = signatureObj.sign();
    return new Signature(jsrsasign.hextob64(signature), keyId, 'ES256');
}
//# sourceMappingURL=ecdsa-signature.js.map